import MenuCodes from "@/utils/menu-codes";

export const headerMenuProps = () => ({
  categories: {
    type: Array,
    required: true
  },
  activeCategory: {
    type: Object,
    required: false,
    default: null
  },
  showMesRepas: {
    type: Boolean,
    required: false,
    default: false
  },
  boutiqueExcluWebId: {
    type: String,
    required: false,
    default: null
  },
  isHomePage: {
    type: Boolean,
    required: false,
    default: false
  },
  isNational: {
    type: Boolean,
    required: false,
    default: false
  }
})

export const useHeaderMenu = (props) => {
  const categoriesWithoutHeader = computed(() => {
    return props.categories.filter(categorie => !categorie.attributes.is_header_selections)
  })
  return { menuCodes: MenuCodes, categoriesWithoutHeader }
}